import {
    getCorrectHistoryPriceData,
    HistoryPriceConfiguration,
    PType,
    showPriceHistoryTooltip
} from "@vpsoftware/vprealestate-www";

export function initPriceHistoryButtons(){
    let buttons = document.querySelectorAll<HTMLImageElement>('.estate-list-section .estate-list-row img.history-price-icon');
    buttons.forEach(button => generateTooltipElement(button));
    
    let propPageButtons = document.querySelectorAll<HTMLImageElement>('#propertySection .container .estate-flat-section img.history-price-icon');
    propPageButtons.forEach(button => generateTooltipElement(button));
}

export function generateTooltipElement(button: HTMLImageElement){
    const investmentSlug = button.dataset['investmentslug'];
    const buildingSlug = button.dataset['buildingslug'];
    const propertyType = button.dataset['propertytype'] as PType;
    const propertyNumber = button.dataset['propertynumber'];
    const kind = button.dataset['kind'];
    const config: HistoryPriceConfiguration = {
        data: getCorrectHistoryPriceData(investmentSlug, buildingSlug, propertyType, propertyNumber, kind === '' ? null : kind),
        config: {
            tooltipPlacement: 'top'
        }
    };
    if(button instanceof HTMLElement){
        showPriceHistoryTooltip(config, button);
    }
}